module.exports = __webpack_public_path__ + "img/111031.431ab314.png";